import React, { PropsWithChildren, useMemo } from "react"

import { useCustomerInfo } from "@cirrus/common/CustomerInfo/context"
import { useHttp } from "@cirrus/core/http/provider"
import { LanguageCode, TranslationsProvider, TranslationsService } from "@cirrus/core/i18n"

export const BasicTranslationsProvider = ({ children }: PropsWithChildren) => {

  const { http } = useHttp()
  const { data } = useCustomerInfo()

  const service = useMemo(() => new TranslationsService({
    getTranslations: (language) => http.get("/api/v1/translations", { params: { lang: language } }),
    getDefaultLanguage: () => {
      const persistedLanguage = (sessionStorage.getItem("loginLang") ?? sessionStorage.getItem("urlLang")) as LanguageCode | null
      return persistedLanguage ?? data?.defaultLanguage ?? "en-GB"
    }
  }), [data?.defaultLanguage])

  return <TranslationsProvider service={service}>{children}</TranslationsProvider>
}
